import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectRouter } from '../../App/utils/selectors';
import { setLogout } from '../../Taps/components/NDFL3/NDFL3Actions';
import LogoutLink from '../components/LogoutLink';
import { startRequest as userLogout } from '../redux/logout/actions';
import { selectLogout } from '../utils/selectors';

const mapStateToProps = (state) => ({
  logout: selectLogout(state),
  router: selectRouter(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      userLogout,
      setLogout,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(LogoutLink);
